import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { RemunerationStatementHistoryClient } from "../../../../../Wrap/Api/Reports/MI/RemunerationStatementHistory";

export class ReportsAction {
    public static getRemunerationStatementHistory(
        fromDate: Date,
        toDate: Date,
        network: string,
        company: string,
        start: number,
        pageSize: number,
        callback
    ) {
        const client = new RemunerationStatementHistoryClient();
        const promise = client.get(
            network,
            company,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            start,
            pageSize,
            true
        );
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }
}
